import React from 'react';
import { Button, Form, Input, InputNumber, Space, Switch, notification } from 'antd';
import { adminMigrateShopifyToCompanies } from '../../api/admin';

const AdminMigrationsTab: React.FC = () => {
  const handle = async (fn: () => Promise<any>) => {
    try {
      await fn();
      notification.success({
        message: 'Migration started',
        description: 'The operation completed successfully.',
        placement: 'topRight',
      });
    } catch (e: any) {
      notification.error({
        message: 'Migration failed',
        description: e?.message || String(e),
        placement: 'topRight',
      });
    }
  };

  return (
    <div>
      <Form
        layout="vertical"
        onFinish={(v) => handle(() => adminMigrateShopifyToCompanies({
          dryRun: v.dryRun,
          copyProducts: v.copyProducts,
          copyMedia: v.copyMedia,
          copyCredentials: v.copyCredentials,
          defaultLevel: v.defaultLevel,
          limit: v.limit || undefined,
          startAfter: v.startAfter || undefined,
        }))}
      >
        <Space wrap>
          <Form.Item name="dryRun" valuePropName="checked" initialValue={true}>
            <Switch checkedChildren="dryRun" unCheckedChildren="run" />
          </Form.Item>
          <Form.Item name="copyProducts" valuePropName="checked" initialValue={false}>
            <Switch checkedChildren="copy products" unCheckedChildren="no products" />
          </Form.Item>
          <Form.Item name="copyMedia" valuePropName="checked" initialValue={false}>
            <Switch checkedChildren="copy media" unCheckedChildren="no media" />
          </Form.Item>
          <Form.Item name="copyCredentials" valuePropName="checked" initialValue={false}>
            <Switch checkedChildren="copy creds" unCheckedChildren="no creds" />
          </Form.Item>
        </Space>
        <Space wrap>
          <Form.Item label="Default level" name="defaultLevel" initialValue={50}>
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item label="Limit" name="limit">
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item label="Start After (shopId)" name="startAfter">
            <Input placeholder="shopId" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">Migrate Shopify → Companies</Button>
          </Form.Item>
        </Space>
      </Form>
    </div>
  );
};

export default AdminMigrationsTab;
